import fromText from './fromText';
import fromRadio from './fromRadio';
import fromSelect from './fromSelect';
import fromTextArea from './fromTextArea';
import fromTextList from './fromTextList';
import fromCheckboxes from './fromCheckboxes';

function generateId() {
  return `${Math.random().toString(36)}00000000000000000`.slice(2, 16 + 2);
}

export default props => {
  const { from, onChange, localSchema, localUiSchema } = props;
  const newSchema = {
    title: localSchema.title,
    type: 'array',
    items: {
      type: 'object',
      properties: {}
    }
  };
  const keys = [];
  for (let i = 0; i < 3; i++) {
    const id = generateId();
    keys.push(id);
    newSchema.items.properties[id] = {
      title: `Column ${i + 1}`,
      type: 'string'
    };
  }
  const updatedForm = {
    schema: newSchema,
    uiSchema: {
      'ui:widget': 'table',
      'ui:headers': keys,
      'ui:description': localUiSchema['ui:description'],
      items: { properties: { 'ui:order': keys } }
    },
    formData: [{}]
  };
  switch (from) {
    case 'text':
      onChange(Object.assign({}, updatedForm, fromText(updatedForm)));
      break;
    case 'textArea':
      onChange(Object.assign({}, updatedForm, fromTextArea(updatedForm)));
      break;
    case 'radio':
      onChange(Object.assign({}, updatedForm, fromRadio(updatedForm)));
      break;
    case 'select':
      onChange(Object.assign({}, updatedForm, fromSelect(updatedForm)));
      break;
    case 'textList':
      onChange(Object.assign({}, updatedForm, fromTextList(updatedForm)));
      break;
    case 'checkboxes':
      onChange(Object.assign({}, updatedForm, fromCheckboxes(updatedForm)));
      break;
    default:
      break;
  }
};



// WEBPACK FOOTER //
// ./webpack/components/Document/Form/Builder/changeQuestionType/toTable/index.js